import { FC, useRef } from 'react';
import Editor from '@draft-js-plugins/editor';
import cn from 'classnames';

import BoldButton from './BoldButton';
import ItalicButton from './ItalicButton';
import { IRichEditorProps } from './RichEditor.interface';
import UnorderedListButton from './UnorderedListButton';
import useEditorPlugins from './useEditorPlugins';
import useSyncedEditorState from './useSyncedEditorState';

import 'draft-js/dist/Draft.css';
import '@draft-js-plugins/static-toolbar/lib/plugin.css';
import './styles.scss';

const RichEditor: FC<IRichEditorProps> = ({
  className,
  active,
  value,
  onFocus,
  onBlur,
  onChange,
}) => {
  const editorRef = useRef<Editor | null>(null);
  const { editorState, handleChange } = useSyncedEditorState(value, onChange);
  const { plugins, Toolbar, LinkButton } = useEditorPlugins();

  return (
    <div className={cn('rich-editor', { 'rich-editor_active': active }, className)}>
      <Editor
        ref={editorRef}
        editorState={editorState}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        plugins={plugins}
      />

      <Toolbar>
        {props => (
          <>
            <BoldButton {...props} />
            <ItalicButton {...props} />
            <UnorderedListButton {...props} />
            <LinkButton {...props} />
          </>
        )}
      </Toolbar>
    </div>
  );
};

export default RichEditor;
